import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormTemplateQuestionFieldsKindEnum } from 'graphql-common';
import { Props } from './types';
import InputPreview from './components/InputPreview';
import TextAreaPreview from './components/TextAreaPreview';
import RadioButtonPreview from './components/RadioButtonPreview';
import CheckboxPreview from './components/CheckboxPreview';
import SingleSelectPreview from './components/SingleSelectPreview';
import YesNoPreview from './components/YesNoPreview';
import NumberInputPreview from './components/NumberInputPreview';
import MinMaxPreview from './components/MinMaxPreview';
import DatePreview from './components/DatePreview';
import DateRangePreview from './components/DateRangePreview';
import TimePreview from './components/TimePreview';
import TimeRangePreview from './components/TimeRangePreview';
import DatetimePreview from './components/DatetimePreview';
import CheckboxButtonGridPreview from './components/CheckboxButtonGridPreview';
import ChecklistPreview from './components/ChecklistPreview';
import RatingPreview from './components/RatingPreview';
import AttachmentPreview from './components/AttachmentPreview';
import DocumentPreview from './components/DocumentPreview';
import DecisionBoxPreview from './components/DecisionBoxPreview';
import ImportantNoticePreview from './components/ImportantNoticePreview';

const componentsMap = {
  [FormTemplateQuestionFieldsKindEnum.Input]: InputPreview,
  [FormTemplateQuestionFieldsKindEnum.TextArea]: TextAreaPreview,
  [FormTemplateQuestionFieldsKindEnum.RadioButton]: RadioButtonPreview,
  [FormTemplateQuestionFieldsKindEnum.Checkbox]: CheckboxPreview,
  [FormTemplateQuestionFieldsKindEnum.SingleSelect]: SingleSelectPreview,
  [FormTemplateQuestionFieldsKindEnum.YesNo]: YesNoPreview,
  [FormTemplateQuestionFieldsKindEnum.NumberInput]: NumberInputPreview,
  [FormTemplateQuestionFieldsKindEnum.MinMax]: MinMaxPreview,
  [FormTemplateQuestionFieldsKindEnum.Date]: DatePreview,
  [FormTemplateQuestionFieldsKindEnum.DateRange]: DateRangePreview,
  [FormTemplateQuestionFieldsKindEnum.Time]: TimePreview,
  [FormTemplateQuestionFieldsKindEnum.TimeRange]: TimeRangePreview,
  [FormTemplateQuestionFieldsKindEnum.Datetime]: DatetimePreview,
  [FormTemplateQuestionFieldsKindEnum.CheckboxButtonGrid]:
    CheckboxButtonGridPreview,
  [FormTemplateQuestionFieldsKindEnum.Checklist]: ChecklistPreview,
  [FormTemplateQuestionFieldsKindEnum.Rating]: RatingPreview,
  [FormTemplateQuestionFieldsKindEnum.Attachment]: AttachmentPreview,
  [FormTemplateQuestionFieldsKindEnum.Document]: DocumentPreview,
  [FormTemplateQuestionFieldsKindEnum.DecisionBox]: DecisionBoxPreview,
  [FormTemplateQuestionFieldsKindEnum.ImportantNotice]: ImportantNoticePreview,
  [FormTemplateQuestionFieldsKindEnum.Section]: undefined,
};

function QuestionFieldPreviewByKind(props: Props) {
  const { kind } = props;
  const { t } = useTranslation();
  const Component = componentsMap[kind];
  if (Component === undefined) return null;
  return <Component {...props} t={t} />;
}

export default memo(QuestionFieldPreviewByKind);
